import { Fragment, ReactElement } from 'react';

import { IProps } from './types';
import * as S from './styles';

export function SliceTagImage({
  slice: { primary, fields },
}: IProps): ReactElement {
  return (
    <S.Wrapper className="slice-item slice-tag-image">
      {fields.map((item, i) => {
        const imgStyles: React.CSSProperties = {
          height: item && item.image_height ? `${item.image_height}px` : 'auto',
          width: item && item.image_width ? `${item.image_width}px` : 'auto',
        };

        const imgMobile =
          (item?.imgmobile && (
            <S.MobileImage
              className="slice-tag-image__mobile"
              src={item?.imgmobile?.url || ''}
              alt="icon"
              width={item?.imgmobile?.dimensions.width || 'auto'}
              style={{ ...imgStyles }}
            />
          )) ||
          null;

        const img =
          (item?.img && (
            <S.DesktopImage
              className="slice-tag-image__desktop"
              src={item?.img?.url || ''}
              alt="icon"
              width={item?.img?.dimensions.width || 'auto'}
              style={{ ...imgStyles }}
            />
          )) ||
          null;

        return (
          <Fragment key={`slice-tag-image-${i}`}>
            {item?.tag_image_link ? (
              <a href={item?.tag_image_link} target="_blank" rel="noreferrer">
                {img}
              </a>
            ) : (
              img
            )}
            {item?.tag_image_link ? (
              <a href={item?.tag_image_link} target="_blank" rel="noreferrer">
                {imgMobile}
              </a>
            ) : (
              imgMobile
            )}
          </Fragment>
        );
      })}
      {primary?.subtitle && (
        <S.SubTitle className="slice-tag-image__subtitle">
          {primary?.subtitle}
        </S.SubTitle>
      )}
    </S.Wrapper>
  );
}

SliceTagImage.componentName = 'tagimage';
